module.exports = __webpack_public_path__ + "img/default-article.f2aacb5.jpg";